"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Avatar_1 = require("../Avatar");
var clsx_1 = __importDefault(require("clsx"));
var AVATAR_STYLES = "bg-lochivar-default mr-2";
var DROP_DOWN_ITEM = "flex flex-row p-0";
var DROP_DOWN_ITEM_BTN = function (args) {
    return "flex " + (args.selected ? "bg-gray-300" : "bg-transparent") + " hover:bg-gray-200 font-md px-2 rounded text-sm w-full text-left";
};
var ITEM_LABEL = "font-semibold truncate";
var ITEM_LABEL_INFORMATIONAL = "font-light truncate text-xs";
var ITEM_ICON = "my-auto mr-2 text-lochivar-default flex-shrink";
var ITEM_SECONDARY_LABEL = "text-xs text-gray-600 flex-shrink truncate";
var DropDownItem = function (_a) {
    var item = _a.item, selected = _a.selected, onMouseOver = _a.onMouseOver, onClick = _a.onClick, avatar = _a.avatar, hideLabels = _a.hideLabels, oversized = _a.oversized;
    return ((0, jsx_runtime_1.jsx)("li", __assign({ className: DROP_DOWN_ITEM, onMouseOver: onMouseOver }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: (0, clsx_1.default)(DROP_DOWN_ITEM_BTN({ selected: selected }), oversized ? "py-2" : "py-1"), onClick: onClick }, { children: [avatar ? ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { name: item.label, size: "sm", className: AVATAR_STYLES, color: item.avatarColor }, void 0)) : null, item.icon ? ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: item.icon, className: (0, clsx_1.default)(ITEM_ICON, oversized ? "text-xl" : "text-md") }, void 0)) : null, !hideLabels ? ((0, jsx_runtime_1.jsxs)("h4", __assign({ className: "my-auto flex flex-col" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: item.informational ? ITEM_LABEL_INFORMATIONAL : ITEM_LABEL }, { children: item.label }), void 0), item.secondaryLabel ? ((0, jsx_runtime_1.jsxs)("span", __assign({ className: ITEM_SECONDARY_LABEL }, { children: ["(", item.secondaryLabel, ")"] }), void 0)) : null] }), void 0)) : null] }), void 0) }), void 0));
};
exports.DropDownItem = DropDownItem;
